export const DEBUG = import.meta.env.VITE_DEBUG === 'true' || false;
/** Application/receipt brand. Kirubet branding is applied only inside the sports ticket print layout. */
export const RETAIL_BRAND_NAME =
  'Trios';
/** Yami API Gateway — default port 8001 (api-gateway `PORT` in .env). Prefer 127.0.0.1 on Windows. */
export const API_URL = (import.meta.env.VITE_API_URL || 'http://127.0.0.1:8001')
  .replace(/\/+$/, '')
  .replace(/\/api$/i, '');
/**
 * Local HTTP print bridge (Betman Retail Manager). Exposes POST /PRINT and
 * POST /ISONLINE (see `Print.ts` / `printerHelpers`).
 *
 * AUTO-DETECTED — no per-PC config. `isPrinterOnline()` probes the candidate
 * ports below and caches whichever one BetManager answers on; everything else
 * then reads that cached URL via `getPrinterUrl()`. BetManager binds the literal
 * host "localhost" (not 127.0.0.1), so all candidates use `localhost`.
 * 8080 is BetManager's default; 8181 is its fallback when 8080 is taken (IIS).
 */
const DEFAULT_PRINTER_URL = 'http://localhost:8080';
const PRINTER_PORT_CANDIDATES = [8080, 8181, 8090, 9080];

function normalizePrinterUrl(input?: string | null): string | undefined {
  const s = (input ?? '').trim();
  if (!s) return undefined;
  if (/^\d{2,5}$/.test(s)) return `http://localhost:${s}`;
  const withScheme = /^https?:\/\//i.test(s) ? s : `http://${s}`;
  return withScheme.replace(/\/+$/, '');
}

const envPrinterUrl = normalizePrinterUrl(import.meta.env.VITE_PRINTER_URL as string | undefined);

let detectedPrinterUrl: string | null = null;

/** Base URLs to probe during auto-detection, in priority order (env hint first). */
export function getPrinterCandidates(): string[] {
  const list: string[] = [];
  if (envPrinterUrl) list.push(envPrinterUrl);
  for (const p of PRINTER_PORT_CANDIDATES) {
    const u = `http://localhost:${p}`;
    if (!list.includes(u)) list.push(u);
  }
  return list;
}

/** The print bridge URL currently in use — the auto-detected one once found. */
export function getPrinterUrl(): string {
  return detectedPrinterUrl || envPrinterUrl || DEFAULT_PRINTER_URL;
}

/** Cache the URL BetManager was found on (set by `isPrinterOnline`). */
export function setDetectedPrinterUrl(url: string | null): void {
  detectedPrinterUrl = url;
}

/** Set `VITE_PRINTER_DISABLED=true` to skip the bridge entirely (host with no printer). */
export function getPrinterDisabled(): boolean {
  return import.meta.env.VITE_PRINTER_DISABLED === 'true';
}
export const SUB_DOMAIN_ROUTING = import.meta.env.VITE_SBR !== 'false';
/** PIN for “Add float” dialog. Empty = disabled. */
export const TILL_ADMIN_PIN = (import.meta.env.VITE_TILL_ADMIN_PIN as string) || '';
